/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.addEventListener('click', function (event) {
  var button = event.target.closest('.search-add-to-cart');

  if (!button) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  var variantId = button.getAttribute('data-variant-id');

  if (!variantId) {
    console.error('Missing variant ID');
    return;
  }

  var originalText = button.textContent;

  button.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: Number(variantId),
      quantity: 1
    })
  })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (error) {
          throw error;
        });
      }

      return response.json();
    })
    .then(function () {
      updateCartCount();
      refreshMiniCart();

      var closeSearchBtn = document.querySelector('[data-action="unfix-search"]');

      if (closeSearchBtn) {
        closeSearchBtn.click();
      }

      setTimeout(function () {
        var cartToggle = document.querySelector('[data-action="toggle-mini-cart"]');

        if (cartToggle && cartToggle.getAttribute('aria-expanded') !== 'true') {
          cartToggle.click();
        }
      }, 150);

      setTimeout(function () {
        button.disabled = false;
      }, 1500);
    });
});

function updateCartCount() {
  fetch('/cart.js')
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      var countElements = document.querySelectorAll(
        '.cart-count, .header__cart-count, [data-cart-count], .cart-link__bubble-num'
      );

      countElements.forEach(function (element) {
        element.textContent = cart.item_count;

        if (cart.item_count > 0) {
          element.classList.remove('hidden');
        }
      });
    });
}

function refreshMiniCart() {
  fetch('/?section_id=mini-cart')
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      var newMiniCart = doc.querySelector('#mini-cart');
      var currentMiniCart = document.querySelector('#mini-cart');

      if (newMiniCart && currentMiniCart) {
        currentMiniCart.innerHTML = newMiniCart.innerHTML;
      }
    });
}